module.exports = __webpack_public_path__ + "static/media/view tour.5abaa1c3.svg";